import React, { useState } from "react";
import axios from "axios";
import { URL_START } from '../../data/config';

const AirlineData = () => {
  const [airlineData, setAirlineData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [icaoInput, setIcaoInput] = useState("");
  const [iataInput, setIataInput] = useState("");
  const [nameInput, setNameInput] = useState("");

  const [logos, setLogos] = useState({});

  // Function to fetch the airline logo based on IATA
  const fetchLogo = async (iataCode) => {
    if (!iataCode) return null; // No IATA code, no logo
    const url = `${URL_START}/api/airline-logo/${iataCode.slice(0, 2)}`;
  
    try {
      const response = await axios.get(url, { responseType: 'blob' });
      if (response.status === 200) {
        return URL.createObjectURL(response.data); // Create a URL for the image
      }
    } catch (error) {
      console.log(`No logo found for IATA code ${iataCode}`);
    }
    return null; // No logo found
  };

  // Function to fetch airline data from the backend
  const fetchAirlineData = async () => {
    setLoading(true);
    try {
      let response;
      if (icaoInput) {
        response = await axios.get(
          `${URL_START}/api/airlines/search/icao?q=${icaoInput}`
        );
      } else if (iataInput) {
        response = await axios.get(
          `${URL_START}/api/airlines/search/iata?q=${iataInput}`
        );
      } else if (nameInput) {
        response = await axios.get(
          `${URL_START}/api/airlines/search/name?q=${nameInput}`
        );
      }

      const data = response.data;

      // For each airline, try to fetch the logo based on IATA code
      const airlinesWithLogos = await Promise.all(
        data.map(async (airline) => {
          const logo = await fetchLogo(airline.iata);
          return { ...airline, logo };
        })
      );

      setAirlineData(airlinesWithLogos); // Store the results with logos in state
    } catch (error) {
      console.error("Error fetching data:", error);
      setAirlineData([]); // In case of error, clear the data
    } finally {
      setLoading(false);
    }
  };

  // Handle key press for search submission (only on "Enter")
  const handleSubmit = (e) => {
    if (e.key === "Enter") {
      fetchAirlineData();
    }
  };

  return (
    <div className="text-white">
      <div className="flex space-x-4 p-2 bg-gray-400">
        <input
          type="text"
          placeholder="ICAO"
          value={icaoInput}
          onChange={(e) => setIcaoInput(e.target.value.toUpperCase())}
          onKeyDown={handleSubmit}
          maxLength={4}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/4 p-1"
        />
        <input
          type="text"
          placeholder="IATA"
          value={iataInput}
          onChange={(e) => setIataInput(e.target.value.toUpperCase())}
          onKeyDown={handleSubmit}
          maxLength={3}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/4 p-1"
        />
        <input
          type="text"
          placeholder="Name"
          value={nameInput}
          onChange={(e) => setNameInput(e.target.value)}
          onKeyDown={handleSubmit}
          className="text-sm pl-2 monospace-font bg-gray-200 text-black border border-gray-600 w-1/2 p-1"
        />
      </div>

      {/* Show message or loading message while fetching */}
      {loading ? (
        <p className="text-center mt-2 text-gray-500">Loading...</p>
      ) : (
        airlineData.length > 0 ? (
          <div className="table-container text-sm overflow-x-auto">
<table className="min-w-full table-auto border-collapse w-full">
  <thead>
    <tr className="bg-gray-400">
      <th className="p-2 text-left">ICAO</th>
      <th className="p-2 text-left">IATA</th>
      <th className="p-2 text-left">Name</th>
      <th className="p-2 text-left">Callsign</th>
      <th className="p-2 text-left">Country</th>
      <th className="p-2 text-left"></th>
    </tr>
  </thead>
  <tbody className="text-black">
    {airlineData.map((airline, index) => (
      <tr
        key={airline.id}
        className={`table-line ${
          index % 2 === 0 ? "bg-gray-600" : "bg-gray-700"
        }`}
      >
        <td className="p-2 border text-left">{airline.icao}</td>
        <td className="p-2 border text-left">{airline.iata || ""}</td>
        <td className="p-2 border text-left">{airline.name}</td>
        <td className="p-2 border text-left">{airline.callsign || ""}</td>
        <td className="p-2 border text-left">{airline.country}</td>
        {/* Display the logo if available */}
        <td className="p-2 border text-left">
          {airline.logo ? (
            <img
              src={airline.logo}
              alt={`${airline.iata} logo`}
              className="w-16 h-auto"
            />
          ) : (
            ""
          )}
        </td>
      </tr>
    ))}
  </tbody>
</table>


          </div>
        ) : (
          <div className="text-center text-sm mt-2 text-gray-500">
            Hit Enter to search
          </div>
        )
      )}
    </div>
  );
};

export default AirlineData;
